module.exports = __webpack_public_path__ + "static/media/5-min.3e8c1de5.png";